import { includes } from '~js/utils'
import server from '~js/server'
import firebaseConfig from '~js/firebase-config'
const FIREBASE_METHOD = {
  PATH: 0,
  STORAGE: 1
}
let urlStart = ''
urlStart = server.firebaseStorageUrlStart

export default class Cubemap {
  constructor (panorama, userId) {
    this.panorama = panorama
    this.userId = userId
    this.filename = ''
    this.preivewUrl = ''
    this.cubeUrl = ''
  }

  init () {
    if (this.panorama.cubemapReady) {
      this.generateCubemapUrl(FIREBASE_METHOD.PATH, 'cubemapFilePath')
    } else if (this.panorama.adjustedRawUrl) { // for filter image 濾鏡圖
      this.generateCubemapUrl(FIREBASE_METHOD.STORAGE, 'adjustedRawUrl')
    } else if (this.panorama.rawUrl) { // firebase latest uploaded image raw url
      this.generateCubemapUrl(FIREBASE_METHOD.STORAGE, 'rawUrl')
    }
  }

  generateCubemapUrl (method = FIREBASE_METHOD.PATH, panoramaKey = '') {
    if (method === FIREBASE_METHOD.PATH) {
      // Firebase cubemapReady = false and cubemapFilePath 有值才會進來但這兩個條件成立根本不會發生(除非改欄位或資料異常)
      this.filename = this.panorama[panoramaKey]
      this.preivewUrl = urlStart + this.panorama[panoramaKey].replace(/panoramas(\/|%2F)/, 'panoramas/cubemap_preview_')
      this.cubeUrl = urlStart + this.panorama[panoramaKey].replace(/panoramas(\/|%2F)/, 'panoramas/cubemap_%s_')
    } else if (method === FIREBASE_METHOD.STORAGE) {
      const url = this.panorama[panoramaKey]
      if (includes(url, 'firebasestorage.googleapis.com') &&
        url.split(firebaseConfig.storageBucket)[1] &&
        url.split(firebaseConfig.storageBucket)[1].split('/o/')[1]) {
        // Firebase url
        this.filename = decodeURIComponent(url.split(firebaseConfig.storageBucket)[1].split('/o/')[1]).split('?')[0]
      } else if (includes(url, firebaseConfig.newStorageBucket) &&
        url.split(`${firebaseConfig.newStorageBucket}/`)) {
        // new GCP url
        this.filename = url.split(`${firebaseConfig.newStorageBucket}/`)[1]
      } else if (includes(url, firebaseConfig.storageBucket) &&
        url.split(`${firebaseConfig.storageBucket}/`)) {
        // old GCP url
        this.filename = url.split(`${firebaseConfig.storageBucket}/`)[1]
      } else if (includes(url, server.firebaseStorageUrlStart)) {
        // cdn url
        this.filename = url.split(server.firebaseStorageUrlStart)[1]
      } else {
        console.warn('filename parse failed')
      }
      if (this.filename) {
        this.preivewUrl = urlStart + this.filename.replace(/panoramas(\/|%2F)/, 'panoramas/cubemap_preview_')
        this.cubeUrl = urlStart + this.filename.replace(/panoramas(\/|%2F)/, 'panoramas/cubemap_%s_')
      }
    }
  }
}
